module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.1-110.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.1.md
// module id = 528
// module chunks = 289